<template>
  <div
    class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
  >
    <div>
      <el-group-title class="ccui-group-wrapper d_jump" index="contract">
        <template slot="groupTitle">
          <anchorTitle
            class="pack_box_anchor"
            v-if="packList && packList.length > 0"
            :tabBtn="packList"
            :isFocus="isFocus"
            :hoverTitle="true"
            @tabBtnChange="tableTopChangePack"
          />
          <el-table
            :data="
              data && data[isFocus] && data[isFocus].sscSupQuoteListBOS
                ? data[isFocus].sscSupQuoteListBOS
                : []
            "
            border
            :span-method="objectSpanMethod"
          >
            <el-table-column
              v-for="(item, index) in columns"
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
            >
              <template slot-scope="scope">
                <span v-if="item.type == 'link' && item.prop == 'supName'">{{
                  scope.row[item.prop]
                }}</span>
                <a
                  class="link-color"
                  href="javascript:void (0)"
                  v-else-if="item.type == 'link' && item.prop == 'amount'"
                  @click="handleSupply(scope.row, data[isFocus])"
                  >{{ scope.row[item.prop] }}</a
                >
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200px">
              <template>
                <el-button size="mini" type="text" @click="associationBtn()">
                  关联关系查询
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-group-title>
    </div>
    <!--查看分包商报价明细-->
    <!-- <supplierOfferDialog
      v-if="offerdialogData.visible"
      :visible.sync="offerdialogData.visible"
      :dialogData="offerdialogData"
      :key="'offer' + new Date().getTime()"
    ></supplierOfferDialog>
  
    <supplierDetailDialog
      v-if="supplydialogData.visible"
      :visible.sync="supplydialogData.visible"
      :dialogData="supplydialogData"
      :key="'detail' + new Date().getTime()"
    ></supplierDetailDialog> -->
    <el-dialog
      :visible.sync="supplierBidDetailsdialogVisible"
      :title="
        `分包商${
          purchaseType == 1 ||
          purchaseType == 2 ||
          purchaseType == 4 ||
          purchaseType == 7 ||
          purchaseType == 8
            ? '响应'
            : '投标'
        }详细信息`
      "
      width="1200px"
      v-if="supplierBidDetailsdialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supCode="formData.supCode"
        :supPackQuoteId="formData.supPackQuoteId"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>
<script>
// import supplierDetailDialog from "../views/supplierDetailDialog";
// import supplierOfferDialog from "../views/supplierOfferDialog";
import {
  scpQryBidOpenRecord,
  // qrySchemeSupCooUnit,
  getUrl
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
export default {
  data() {
    // let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType,
      packList: [],
      supplierBidDetailsdialogVisible: false,
      isFocus: "0",
      data: [],
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件Id
      },
      columns: [
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "supName",
          label: "分包商名称",
          type: "link"
        }
        // {
        //   prop: "amount",
        //   label: `投标报价（${
        //     JSON.parse(sessionStorage.getItem("moneyData")).unit
        //   }）`,
        //   labelChild: [],
        //   width: 300,
        //   align: "right",
        //   type: "link"
        // }
      ],
      offerdialogData: {
        visible: false,
        data: {},
        title: "查看分包商报价明细"
      },
      supplydialogData: {
        visible: false,
        data: {},
        title: "分包商详细信息"
      }
    };
  },
  components: {
    // supplierDetailDialog,
    supplierBidDetails
    // supplierOfferDialog
  },
  props: {},
  watch: {
    columns: {
      handler(newVal) {
        if (
          this.purchaseType == 1 ||
          this.purchaseType == 2 ||
          this.purchaseType == 4 ||
          this.purchaseType == 7 ||
          this.purchaseType == 8
        ) {
          newVal.forEach(item => {
            if (item.prop == "amount") {
              item.label = `响应报价（${
                JSON.parse(sessionStorage.getItem("moneyData")).unit
              }）`;
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //投标金额跳转
    handleSupply(row, data) {
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supCode = row.supCode;
      if (data) {
        this.formData.packId = data.packId;
      } else {
        this.formData.packId = "";
      }
      this.supplierBidDetailsdialogVisible = true;
    },
    geqryBidOpenRecord() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: this.$router.history.current.query.menuKey,
        evaPurStep: this.$router.history.current.query.evaPurStep,
        isShowPageLoading: true
      };
      if (param.evaPurStep === "801") {
        param.purStep = "0701";
      } else if (param.evaPurStep === "802") {
        param.purStep = "0702";
      }
      scpQryBidOpenRecord(param).then(res => {
        if (res.data.code === "0") {
          let packList = [];
          res.data.data.sscSupQuoteListResultBOS.forEach((item, key) => {
            item.sscSupQuoteListBOS.forEach((itemtow, indextow) => {
              itemtow.id = indextow + 1;
              itemtow.packId = item.packId;

              if (itemtow.amount) {
                itemtow.amount = new BigNumber(itemtow.amount).toFormat(2);
              } else {
                itemtow.amount = "";
              }
            });
            if (item.packName) {
              if (
                item.packStatus !== undefined &&
                item.packStatus !== null &&
                item.packStatus !== "" &&
                item.packStatus != 1
              ) {
                item.packName += "（已流标）";
              }
              packList.push({
                label: item.packName,
                value: key + ""
              });
            }
          });

          this.packList = packList;
          this.data = res.data.data.sscSupQuoteListResultBOS;
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        // if (rowIndex % 2 === 0) {
        return {
          rowspan: this.data[this.isFocus].sscSupQuoteListBOS.length,
          colspan: 1
        };
        // } else {
        //   return {
        //     rowspan: 0,
        //     colspan: 0
        //   };
        // }
      }
    },
    tableTopChangePack({ value }) {
      //切换包件
      this.isFocus = value + "";
    },
    //关联关系查询
    associationBtn() {
      getUrl({}).then(res => {
        let url = res.data.data.url + "/webapi/plugin/supply/relationship";
        let supNameBox = [];
        if (this.data[this.isFocus].sscSupQuoteListBOS.length > 0) {
          this.data[this.isFocus].sscSupQuoteListBOS.forEach(item => {
            if (!isNaN(item.id)) {
              supNameBox.push(item.supName);
            }
          });
        }
        window.open(
          `${url}?companyNames=${encodeURIComponent(
            supNameBox.toString()
          )}&type=3&token=${res.data.data.token}&timespan=${
            res.data.data.timespan
          }&appId=${res.data.data.appid}`
        );
      });
    }
  },
  mounted() {
    this.geqryBidOpenRecord();
  }
};
</script>
<style lang="scss" scoped>
.link-color {
  color: #0089ef;
  width: 100%;
  display: inline-block;
  text-align: right;
  padding-right: 5px;
}

.el-table .cell.el-tooltip {
  border-right: 1px solid #edf2fc !important;
}

/deep/ .el-table__row td {
  border-right: 1px solid #edf2fc !important;
}

/deep/ .el-table--border td {
  border-right: 1px solid #edf2fc !important;
}

/deep/ .el-table__header th {
  border-right: 1px solid #edf2fc !important;
}
.pack_box_anchor {
  margin-bottom: 20px;
  width: calc(100% - 40px);
  line-height: 40px;
  background-color: #f5f5f5;
  padding: 0 20px;
  /deep/ .el-button {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    padding: 0;
    position: relative;
    top: 7px;
    margin-left: 0;
    margin-right: 30px;
  }
  /deep/ span {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
</style>
